






























































import {Component, Vue, Watch} from 'vue-property-decorator';
import {ISheetOrder} from '@/models/ISheetOrder';
import {getSheetOrders, IFilterFulfillment} from '@/services/SheetOrderService';
import {DataTableHeader} from 'vuetify';
import FulfillmentOrderTable from '@/screens/dashboard/fulfillment/FulfillmentOrderTable.vue';
import PublishFulfillmentBtn from '@/screens/dashboard/fulfillment/PublishFulfillmentBtn.vue';
import {VPaginationRequestData} from '@/utils/VPaginationRequestData';
import {Debounce} from '@/decorators/DebounceDecorator';
import DetailLineItemsTable from '@/screens/dashboard/fulfillment/DetailLineItemsTable.vue';
import {ModuleShop} from '@/store/modules/ShopModule';
import UploadFileBtn from '@/screens/dashboard/fulfillment/UploadFileBtn.vue';
import {ModuleOrganization} from '@/store/modules/OrganizationModule';

@Component({
  components: {
    DetailLineItemsTable,
    FulfillmentOrderTable,
    PublishFulfillmentBtn,
    UploadFileBtn
  }
})
export default class Fulfillments extends Vue {
  protected showDetail: boolean = false;
  protected loading: boolean = true;
  protected sheetOrders: ISheetOrder[] = [];
  protected expanded: ISheetOrder[] = [];
  protected paginationRequestData: VPaginationRequestData<IFilterFulfillment> = new VPaginationRequestData({
    query: ''
  });

  protected headers: DataTableHeader[] = [
    {text: 'Name', align: 'start', sortable: false, value: 'sheet_name', },
    {text: 'Supplier', align: 'start', sortable: true, value: 'supplier.id', },
    {text: 'Google Sheet', align: 'start', sortable: false, value: 'gg_spread_sheet_id', },
    {text: 'Status', align: 'start', sortable: false, value: 'status', width: 150, },
    {text: 'Actions', align: 'start', sortable: false, value: 'name', width: 250, },
  ];

  get shopId() {
    return ModuleShop.shopId;
  }

  get organizationId() {
    return ModuleOrganization.organizationId;
  }

  @Watch('shopId', {immediate: true})
  public async loadData() {
    this.loading = true;
    try {
      this.sheetOrders = [];
      this.sheetOrders = await getSheetOrders(this.organizationId, this.shopId, this.paginationRequestData);
    } finally {
      this.loading = false;
    }
  }

  protected expandRow(item: ISheetOrder) {
    if (this.expanded.length === 1) {
      this.expanded = [];
    } else {
      this.expanded = [item];
    }
  }

  protected onSuccess(success: boolean) {
    if (success) {
      this.loadData();
    }
  }


  @Watch('paginationRequestData.filterData', {deep: true})
  @Debounce(500)
  onFilterDataChange() {
    this.loadData();
  }
}
